<template>
  <PlatformLayout :useOverlay="overlay">
    <v-card rounded max-width="1366" class="d-block mx-auto">
      <v-card-title>
        <v-row>
          <v-col cols="12" md="6">
            <h5 class="text-h5 font-weight-bold text-left">
              Familias&nbsp;<v-icon large>mdi-group</v-icon>
            </h5>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end">
            <v-btn color="primary" class="mr-lg-1" @click="openAddDialog">
              <v-icon>mdi-plus</v-icon>Agregar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :search="search"
          :headers="headers"
          :items="familias"
          :items-per-page="20"
          :footer-props="{
            itemsPerPageText: 'El. por página',
            itemsPerPageAllText: 'Todo',
            itemsPerPageOptions: ippoptions,
          }"
          no-results-text="No hay resultados"
          no-data-text="No hay datos para mostrar"
        >
          <template v-slot:top>
            <v-text-field v-model="search" label="Buscar"></v-text-field>
          </template>
          <template v-slot:item.acciones="{ item }">
            <v-btn
              class="ma-1"
              color="accent"
              fab
              small
              @click="openDialog(item)"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
            <v-btn
              class="ma-1"
              color="warning"
              fab
              small
              @click="requestDeleteFamily(item)"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <FamiliasDialog
      :trigger="dialog"
      :family="selectedFamily"
      @onAddRequest="addFamily"
      @onEditRequest="editFamily"
      @onCancel="resetDialog"
    />
    <ConfirmationDialog
      :dialog_ref="deleteDialog"
      :dialogTitle="'Eliminar familia'"
      :dialogMsg="'¿Está seguro que desea elimnar esta familia? Esta acción no se puede deshacer y los productos pertenecientes a ella se quedarán sin familia.'"
      :confirmBtnText="'Eliminar'"
      :confirmBtnIcon="'mdi-delete'"
      :confirmBtnStyle="'warning'"
      @onConfirm="deleteFamily"
      @onCancel="resetDialog"
    />
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "@/components/PlatformLayout.vue";
import FamiliasDialog from "@/components/Familias/FamiliasDialog.vue";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import { httpDelete, httpGet, httpPost, httpPut } from "@/services/apiService";

export default {
  name: "familias",
  components: {
    PlatformLayout,
    FamiliasDialog,
    ConfirmationDialog,
  },
  created() {
    this.getData();
  },
  data: () => ({
    overlay: false,
    search: "",
    headers: [
      {
        text: "Nombre",
        align: "center",
        sortable: true,
        value: "attributes.nombre",
      },
      {
        text: "Acciones",
        align: "center",
        sortable: false,
        value: "acciones",
      },
    ],
    familias: [],
    ippoptions: [10, 20, 30, 40, 50, -1],
    sheets: [],
    dialog: false,
    selectedFamily: null,
    deleteDialog: false,
    selectedForDeletion: null,
  }),
  methods: {
    async getData() {
      this.overlay = true;
      const { data } = await httpGet("/subfamilias?pagination=false").catch(
        (err) => {
          this.overlay = false;
          this.$toasted.show("Ha ocurrido un error al obtener la información.");
          throw err;
        }
      );

      this.familias = data?.data;
      (this.familias);
      this.overlay = false;
    },
    openAddDialog() {
      this.dialog = true;
    },
    openDialog(item) {
      this.selectedFamily = item;
      this.dialog = true;
    },
    async addFamily(event) {
      const { data, error } = await httpPost("/subfamilias", { data: event });
      if (error) {
        this.$toasted.show(
          "Ha ocurrido un error al agregar la familia. Intente de nuevo más tarde.",
          { type: "error" }
        );
        this.resetDialog();
        return;
      }

      if (data) {
        this.$toasted.show("Familia agregada. Actualizando el catálogo...", {
          type: "success",
        });
        this.getData();
        this.resetDialog();
      }
    },
    async editFamily(event) {
      const { data, error } = await httpPut("/subfamilias/" + event.id, {
        data: event,
      });

      if (error) {
        this.$toasted.show(
          "Ha ocurrido un error al editar la familia. Intente de nuevo más tarde.",
          { type: "error" }
        );
        this.resetDialog();
        return;
      }

      if (data) {
        this.$toasted.show("Familia editada. Actualizando el catálogo...", {
          type: "success",
        });
        this.getData();
        this.resetDialog();
      }
    },
    async deleteFamily() {
      const { data, error } = await httpDelete(
        "/subfamilias/" + this.selectedForDeletion.id
      );
      if (error) {
        this.$toasted.show(
          "Ha ocurrido un error al eliminar el familia. Intente de nuevo más tarde.",
          { type: "error" }
        );
        this.resetDialog();
        return;
      }

      if (data) {
        this.$toasted.show("familia eliminado. Actualizando el catálogo...", {
          type: "success",
        });
        this.getData();
        this.resetDialog();
      }
    },
    requestDeleteFamily(event) {
      this.selectedForDeletion = event;
      this.deleteDialog = true;
    },
    resetDialog() {
      this.dialog = false;
      this.deleteDialog = false;
      this.selectedFamily = null;
      this.selectedForDeletion = null;
    },
  },
};
</script>
